import LoginForm from 'components/ui/dataEntry/forms/LoginForm'
import React, { useEffect, useState } from 'react'
import ForgotPassword from './ForgotPassword'
import { message } from 'antd'
import userMessages from 'constants/messages'
import { utilityService } from 'services/UtilityService'
import { confirmSignIn, fetchUserAttributes, getCurrentUser, setUpTOTP, signIn, signOut, updateMFAPreference, verifyTOTPSetup } from 'aws-amplify/auth'
import ConfirmOtp from './ConfirmOtp'
import { flowRight as compose } from 'lodash'
import { graphql, withApollo } from '@apollo/client/react/hoc'
import QueryUserSettings from '../../graphQL/mfaSettings/checkUser2faStatus'
import EnableMfa from './EnableMfa'
import AuthService from 'services/AuthService'
import { getQRCode } from '../../util/util'
import AddMfaDevices from 'components/ui/feedback/AddMfaDevicesModal'
import { withRouter } from 'react-router-dom'
import RequireNewPassword from './RequireNewPassword'

const LOGIN_SCREEN_TYPES = {
  CONFIGURE_MFA_BEFORE_LOGIN: 'CONFIGURE_MFA_BEFORE_LOGIN',
  'SING_IN': 'SING_IN',
  'FORGOT_PASSWORD': 'FORGOT_PASSWORD',
  // user  needs to enter mfa code, its mfa device is already added from dashboard
  'CONFIRM_SIGN_IN_WITH_TOTP_CODE': 'CONFIRM_SIGN_IN_WITH_TOTP_CODE',
  'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED': 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED'
}

const Login = ({
  route,
  getUserMfaStatus,
  history
}) => {
  const [loginState, setLoginState] = useState(LOGIN_SCREEN_TYPES.SING_IN)

  // Individual state hooks
  const [userName, setUserName] = useState()
  const [isMfaConfirmModalLoading, setIsMfaConfirmModalLoading] = useState(false)
  const [isMfaDeviceModalVisible, setIsMfaDeviceModalVisible] = useState(false)
  const [secretKey, setSecretKey] = useState('')
  const [isEnableMfaLoading, setIsEnableMfaLoading] = useState(false)
  const [isAddDeviceModalLoading, setIsAddDeviceModalLoading] = useState(false)

  const [isLoginFormLoading, setIsLoginFormLoading] = useState(false)
  const [qrCode, setQrCode] = useState('')

  const onLoginSubmit = async (username, password, shouldRember) => {
    setIsLoginFormLoading(true)
    setUserName(username)
    const project = utilityService.getCurrentProject()
    const browserAndOsDetails = utilityService.getBrowserDetails()
    try {
      const { nextStep } = await signIn({
        username,
        password,
        options: {
          clientMetadata: {
            meta: window.config.meta,
            sessionId: new Date().getTime().toString(),
            project: project,
            userAgent: browserAndOsDetails
          }
        }
      })
      // show mfa entering screen
      if (nextStep.signInStep === 'CONFIRM_SIGN_IN_WITH_TOTP_CODE') {
        setLoginState(LOGIN_SCREEN_TYPES.CONFIRM_SIGN_IN_WITH_TOTP_CODE)
        setIsLoginFormLoading(false)
      } else if (nextStep.signInStep === 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED') {
        // user was invited after using passwrd from mail, show new password creation page
        setLoginState(LOGIN_SCREEN_TYPES.CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED)
        setIsLoginFormLoading(false)
      } else {
        getUserMfaStatus({
          user: username,
          project,
          isFirstSignIn: true,
          userAgent: browserAndOsDetails
        })
          .then(({ data }) => {
            if (!data.checkUserAccess.projectAccess) {
              message.error(`You don't have access to this to project`)
              return
            }
            if (data.checkUserAccess.mfaStatus) {
              history.push('/assets')
            } else {
              setLoginState(LOGIN_SCREEN_TYPES.CONFIGURE_MFA_BEFORE_LOGIN)
            }
            setIsLoginFormLoading(false)
          }).catch(async _ => {
            await signOut()
            setIsLoginFormLoading(false)
          })
      }
      // if (authUser.challengeName === 'SOFTWARE_TOKEN_MFA') {
      //   setIsMfaModalVisible(true)
      //   setUser(authUser)
      // } else if (authUser.challengeName === 'NEW_PASSWORD_REQUIRED') {
      //   message.success(userMessages.LOGIN_FORCE_RESET)
      //   // In functional components, this.changeState is usually props.onStateChange
      //   props.onStateChange(requirePasswordState, authUser)
      // } else {
      // // Call GQL status check
      //   props.getUserMfaStatus({ user: username, project }).then(({ data }) => {
      //     if (!data.checkUserAccess.projectAccess) {
      //       message.error(`You don't have access to this to project`)
      //       setIsSuccess(true)
      //       return
      //     }

      //     const needsMfaSetup = !authUser.challengeName || authUser.challengeName === 'NOMFA'

      //     if (data.checkUserAccess.mfaStatus && needsMfaSetup) {
      //       props.onStateChange(signedUpState, authUser)
      //     } else {
      //       setIsMfaEnabled(true)
      //       setUser(authUser)
      //     }
      //     setIsSuccess(true)
      //   })
      // }
    } catch (errorMsg) {
      setIsLoginFormLoading(false)
      utilityService.handleError(errorMsg)
    }
  }

  const onConfirmOtpSubmit = async (secretKey, setupCode) => {
    const browserAndOsDetails = utilityService.getBrowserDetails()
    const project = utilityService.getCurrentProject()
    try {
      const options = {
        clientMetadata: {
          meta: window.config.meta,
          sessionId: new Date().getTime().toString(),
          project: project,
          userAgent: browserAndOsDetails
        }
      }
      setIsMfaConfirmModalLoading(true)
      const { isSignedIn } = await confirmSignIn({
        challengeResponse: secretKey,
        options // Pass your metadata here
      })
      if (isSignedIn) {
        await getUserMfaStatus({
          user: userName,
          project,
          isFirstSignIn: true,
          userAgent: browserAndOsDetails
        })
        setIsMfaConfirmModalLoading(false)
        history.push('/assets')
      }
    } catch (error) {
      utilityService.handleError(error)
      setIsMfaConfirmModalLoading(false)
    }
  }

  const onConfigureMFABeforeLogin = async (secretKey, setupCode) => {
    try {
      setIsAddDeviceModalLoading(true)
      await verifyTOTPSetup({ code: secretKey })
      await updateMFAPreference({
        totp: 'PREFERRED'
      })
      history.push('/assets')
      setIsAddDeviceModalLoading(false)
    } catch (error) {
      setIsAddDeviceModalLoading(false)
      utilityService.handleError(error)
    }
  }

  const onContinueMfa = async () => {
    try {
      setIsEnableMfaLoading(true)
      const totpSetupDetails = await setUpTOTP()
      const code = totpSetupDetails.sharedSecret
      const user = await fetchUserAttributes()
      const domainName = utilityService.getEnvironment()
      const accountName = domainName ? `Optus CMS - ${domainName}` : 'Optus CMS'
      const qrCode = getQRCode(accountName, user.name, code)
      setIsMfaDeviceModalVisible(true)
      setQrCode(qrCode)
      setSecretKey(code)
      setIsEnableMfaLoading(false)
    } catch (error) {
      setIsEnableMfaLoading(false)
      utilityService.handleError(error)
    }
    // Auth.setupTOTP(user).then(
    //   code => {
    //     const domainName = utilityService.getEnvironment()
    //     const accountName = domainName ? `Optus CMS - ${domainName}` : 'Optus CMS'
    //     const authCode = `otpauth://totp/${accountName}:${this.state.user.username}?secret=${code}&issuer=${accountName}`
    //     // const authCode = 'otpauth://totp/AWSCognito:' + this.state.user.username + '?secret=' + code + '&issuer=AWSCognito'
    //     this.setState({
    //       qrCode: authCode,
    //       isMfaDeviceModalVisible,
    //       isEnableMfaLoading: false,
    //       secretKey: code
    //     })
    //   },
    //   error => {
    //     const errorMessage =
    //       error && error.message ? error.message : 'Something went wrong please try again later'
    //     message.error(errorMessage)
    //     this.setState({
    //       qrCode: '',
    //       isMfaDeviceModalVisible: false,
    //       isEnableMfaLoading: false,
    //       secretKey: ''
    //     })
    //   }
    // )
  }

  useEffect(() => {
    async function checkUser () {
      try {
        const currentUser = await getCurrentUser()
        console.log('currentUser', currentUser)
        history.push('/assets')
      } catch (err) {
        // setUser(null)
      }
    }
    checkUser()
  }, [])

  let formToShow = null

  // login screen
  if (loginState === LOGIN_SCREEN_TYPES.SING_IN) {
    formToShow = (
      <LoginForm
        onForgotClick={() => {
          setLoginState(LOGIN_SCREEN_TYPES.FORGOT_PASSWORD)
        }}
        onSelect={onLoginSubmit}
        isLoginFormLoading={isLoginFormLoading}
      />
    )
  }

  // forgot password screen
  if (loginState === LOGIN_SCREEN_TYPES.FORGOT_PASSWORD) {
    formToShow = (
      <ForgotPassword
        loginClicked={() => {
          setLoginState(LOGIN_SCREEN_TYPES.SING_IN)
        }}
        onSubmit={() => {
          message.success(userMessages.AUTH_PASSWORD_SET_SUCCESS)
          setLoginState(LOGIN_SCREEN_TYPES.SING_IN)
        }}
      />
    )
  }

  // user has configureed mfa and need to enter it
  if (loginState === LOGIN_SCREEN_TYPES.CONFIRM_SIGN_IN_WITH_TOTP_CODE) {
    formToShow = (
      <ConfirmOtp
        handleCancel={() => setLoginState(LOGIN_SCREEN_TYPES.SING_IN)}
        handleSubmit={onConfirmOtpSubmit} // confirmLogin
        isLoading={isMfaConfirmModalLoading}
      />
    )
  }

  // user has not configured mfa, its mandatory so ask user to configure mfa after login
  if (loginState === LOGIN_SCREEN_TYPES.CONFIGURE_MFA_BEFORE_LOGIN) {
    formToShow = (
      <EnableMfa
        onLogout={async () => {
          await signOut()
          AuthService.clearUserDetails()
          setLoginState(LOGIN_SCREEN_TYPES.SING_IN)
          // Hub.listen('auth', this)
        }}
        onSuccess={onContinueMfa}
        isEnableMfaLoading={isEnableMfaLoading}
      />
    )
  }

  // user was invited, need to create new passwrd based on password he got from mail
  if (loginState === LOGIN_SCREEN_TYPES.CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED) {
    formToShow = (
      <RequireNewPassword
        userName={userName}
      />
    )
  }

  return (
    <div className='login'>
      {formToShow}
      <AddMfaDevices
        isVisible={isMfaDeviceModalVisible}
        handleCancel={() => setIsMfaDeviceModalVisible(false)}
        qrCode={qrCode}
        secretKey={secretKey}
        isLoading={isAddDeviceModalLoading}
        handleSubmit={onConfigureMFABeforeLogin}
      />
    </div>
  )
}

export default withRouter(withApollo(
  compose(
    graphql(QueryUserSettings, {
      options: () => {
        const project = utilityService.getCurrentProject()
        return {
          fetchPolicy: 'network-only',
          variables: { user: '', project }
        }
      },
      props: props => {
        return {
          getUserMfaStatus: user => {
            return props.data.refetch(user)
          }
        }
      }
    })
  )(Login)
))
